<script setup>
import { __, getFormValuesFromLocalStorage, getZipCode, setFormValues } from '@/utils';
import { useField } from 'vee-validate';
import { ref, inject } from 'vue';
import debounce from 'lodash/debounce';
import FieldCity from '@components/fieldCity/fieldCity.vue';
import FieldStreet from '@components/fieldStreet/fieldStreet.vue';
import FieldsAddress from '@components/fieldsAddress/fieldsAddress.vue';
import { useDisableCityField } from '@composables/useDisableCityField';

const { type } = defineProps(['type']);
const { showLoader } = inject('step2');
 
const savedFields = getFormValuesFromLocalStorage();
const { handleChange: handleCityCode } = useField(`${type}CityCode`);
const { handleChange: handleStreetCode } = useField(`${type}StreetCode`);
const { handleChange: handleZipCode} = useField('zipCode');
const { handleChange: handleZipStatus } = useField(`${type}ZipStatus`)

const cityCode = ref(savedFields?.[`${type}CityCode`] ? savedFields?.[`${type}CityCode`] : '');

const fetchZipCode = debounce(async() => {
    showLoader.value = true;
    const response = await getZipCode(type);
    if ( response ) {
        const apiResponse = JSON.parse(response.data);
        const zipCode = apiResponse.response[0]?.name;

        handleZipStatus(apiResponse.response['error']);

        if (zipCode) {
            handleZipCode(zipCode);
            let zipCodeType = 'zipCode';
            setFormValues({
                [zipCodeType]: zipCode
            })
        }else{
            handleZipCode('');
        }
    }else{
        handleZipCode('');
    }

    showLoader.value = false;
}, 300);

const handleSelectedCity = ({code}) => {
    handleCityCode(code);
    cityCode.value = code;
    fetchZipCode();
}

const handleSelectedStreet = ({ code }) => {
    handleStreetCode(code);
    fetchZipCode();
}

const { disableCityField } = useDisableCityField(type);
</script>
<template>
    <div class="fields__body">
        <FieldCity
            :name="`${type}Settlement`"
            :type="type"
            :label="`${__('Settlement')} *`"
            @selected="handleSelectedCity" 
            :disabled="disableCityField"
            :isShipping="false"
        />

        <FieldStreet 
            :name="`${type}Street`"
            :type="type"
            :label="`${__('Street')} *`"
            :city_code="cityCode"
            :disabled="!cityCode"
            @selected="handleSelectedStreet"
            :isShipping="false"
        />

        <FieldsAddress :type="type" :isShipping="false" />
    </div><!-- /.fields__body -->
</template>